// import React, { useState, useEffect } from 'react'
// import {
//   Drawer,
//   TextField,
//   Button,
//   Typography,
//   Select,
//   MenuItem,
//   Box,
//   FormControl,
//   InputLabel
// } from '@mui/material'
// import CloseIcon from '@mui/icons-material/Close'
// import './AddUserPopup.css'
// import axios from 'axios'
// import { useSelector } from 'react-redux'
// // Custom Alert Component
// const CustomAlert = ({ show, message, type, onConfirm, onCancel }) => {
//   if (!show) return null

//   return (
//     <div className='custom-alert-overlay'>
//       <div className='custom-alert-box'>
//         <div className='custom-alert-content'>
//           <h3>{type === 'confirm' ? 'Confirm' : 'Alert'}</h3>
//           <p>{message}</p>
//           <div className='custom-alert-buttons'>
//             {type === 'confirm' && (
//               <button className='alert-cancel-btn' onClick={onCancel}>
//                 Cancel
//               </button>
//             )}
//             <button className='alert-confirm-btn' onClick={onConfirm}>
//               {type === 'confirm' ? 'Yes' : 'OK'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// const AddUserPopup = ({
//   open,
//   onClose,
//   onSubmit,
//   isEditMode = false,
//   userData = null
// }) => {
//   const userDataStore = useSelector(state => state.appStore?.user)
//   console.log('52', userDataStore)

//   const [formData, setFormData] = useState({
//     role: 'Agent',
//     firstName: '',
//     lastName: '',
//     mobile: '',
//     email: '',
//     username: '',
//     password: '',
//     confirmPassword: '',
//     adhaarNumber: '',
//     userID: '',
//     orgID: '',
//     orgName: ''
//   })

//   const [formErrors, setFormErrors] = useState({})

//   // Alert states
//   const [alertConfig, setAlertConfig] = useState({
//     show: false,
//     message: '',
//     type: 'alert', // 'alert' or 'confirm'
//     onConfirm: () => {},
//     onCancel: () => {}
//   })

//   // Populate form data when editing
//   useEffect(() => {
//     if (isEditMode && userData) {
//       setFormData({
//         role: userData.userType || 'Agent',
//         firstName: userData.FirstName || '',
//         lastName: userData.LastName || '',
//         mobile: userData.MobileNumber || '',
//         email: userData.email || '',
//         username: userData.username || '',
//         password: '',
//         confirmPassword: '',
//         adhaarNumber: userData.adhaarNumber || '',
//         userID: userData.userID || '',
//         orgID: userData.orgID || '',
//         orgName: userData.orgName || ''
//       })
//     } else if (!isEditMode) {
//       // Reset form when not in edit mode
//       setFormData({
//         role: 'Agent',
//         firstName: '',
//         lastName: '',
//         mobile: '',
//         email: '',
//         username: '',
//         password: '',
//         confirmPassword: '',
//         adhaarNumber: '',
//         userID: '',
//         orgID: '',
//         orgName: ''
//       })
//     }
//   }, [isEditMode, userData, open])

//   const handleInputChange = e => {
//     setFormData({ ...formData, [e.target.name]: e.target.value })
//     setFormErrors({ ...formErrors, [e.target.name]: '' }) // Clear error when user types
//   }

//   const validateForm = () => {
//     let errors = {}
//     if (!formData.firstName) errors.firstName = 'First Name is required'
//     if (!formData.lastName) errors.lastName = 'Last Name is required'
//     if (!formData.mobile) errors.mobile = 'Mobile Number is required'
//     if (!formData.email) errors.email = 'Email is required'

//     if (formData.role === 'Agent') {
//       if (!formData.username) errors.username = 'Username is required'

//       // Only validate password in add mode, not edit mode
//       if (!isEditMode) {
//         if (!formData.password) errors.password = 'Password is required'
//         if (formData.password !== formData.confirmPassword) {
//           errors.confirmPassword = 'Passwords do not match'
//         }
//       } else if (
//         formData.password &&
//         formData.password !== formData.confirmPassword
//       ) {
//         // In edit mode, only validate password if one is provided
//         errors.confirmPassword = 'Passwords do not match'
//       }
//     } else if (formData.role === 'Executive' && !formData.adhaarNumber) {
//       errors.adhaarNumber = 'Aadhaar Number is required'
//     }
//     return errors
//   }

//   const handleFormSubmit = async () => {
//     const errors = validateForm()
//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors)
//       return
//     }
//     try {
//       const user = localStorage.getItem('insuranceUser')
//       const user_info = JSON.parse(user)
//       const token = user_info?.token
//       const orgID =
//         userDataStore?.orgID ||
//         formData.orgID ||
//         user_info?.org_id ||
//         sessionStorage.getItem('loggedInUser') ||
//         'defaultOrg'

//       let orgName = ''

//       // ✅ Fetch org_name from backend if not present
//       if (!orgName) {
//         try {
//           const response = await axios.get('/auth/organisation_details', {
//             params: { org_id: orgID },
//             headers: {
//               Authorization: `Bearer ${token}`
//             }
//           })

//           if (response.status === 200 && response.data?.result?.length > 0) {
//             orgName = response.data.result[0].org_name
//             console.log("180",orgName);
            
//           } else {
//             console.error('Organisation not found for org_id:', orgID)
//           }
//         } catch (err) {
//           console.error('Error fetching organisation details:', err)
//         }
//       }

//       // If editing, use existing userID, otherwise generate a new one
//       const userID = isEditMode
//         ? formData.userID
//         : `USR_${(Date.now() % 1000000) + Math.floor(Math.random() * 1000)}`

//       if (isEditMode) {
//         // Update existing agent using the existing endpoint
//         // Since there's no direct update endpoint, we'll delete and recreate the agent
//         try {
//           // First delete the existing agent
//           await axios.delete(`/validOrganisation/orgAgentDelete/${userID}`)

//           // Then recreate with updated information
//           const agentData = {
//             FirstName: formData.firstName,
//             LastName: formData.lastName,
//             MobileNumber: formData.mobile,
//             email: formData.email,
//             username: formData.username,
//             password: formData.password || '', // Use empty string if no new password
//             adhaarNumber: formData.adhaarNumber || '',
//             createdAt: userData.createdAt || new Date().toISOString(),
//             updatedAt: new Date().toISOString(),
//             userID,
//             orgID,
//             orgName
//           }

//           // Add the agent back
//           await axios.post('/auth/addAgent', agentData, {
//             headers: { Authorization: `Bearer ${token}` }
//           })

//           // Update user type if needed
//           if (userData.userType !== formData.role) {
//             // If user type changed, update it in auth system
//             await axios.post(
//               '/auth/addUser',
//               {
//                 email: formData.email,
//                 password: formData.password || 'no_password_change', // Use placeholder if no password change
//                 usertype: formData.role,
//                 userID,
//                 orgName
//               },
//               {
//                 headers: { Authorization: `Bearer ${token}` }
//               }
//             )
//           }

//           // alert("Agent updated successfully!");

//           // Call onSubmit with the updated agent data
//           // onSubmit(agentData);
//           // Show success message with custom alert
//           setAlertConfig({
//             show: true,
//             message: 'Agent updated successfully!',
//             type: 'alert',
//             onConfirm: () => {
//               setAlertConfig({ ...alertConfig, show: false })
//               // Call onSubmit with the updated agent data
//               onSubmit(agentData)
//               onClose()
//             }
//           })
//         } catch (error) {
//           console.error(
//             'Error updating agent:',
//             error.response?.data || error.message
//           )
//           // alert(`Failed to update agent: ${error.response?.data?.message || error.message}`);
//           // Show error message with custom alert
//           setAlertConfig({
//             show: true,
//             message: `Failed to update agent: ${
//               error.response?.data?.message || error.message
//             }`,
//             type: 'alert',
//             onConfirm: () => setAlertConfig({ ...alertConfig, show: false })
//           })
//         }
//       } else {
//         // Add new agent - use existing flow
//         const agentData = {
//           FirstName: formData.firstName,
//           LastName: formData.lastName,
//           MobileNumber: formData.mobile,
//           email: formData.email,
//           username: formData.username,
//           password: formData.password,
//           adhaarNumber: formData.adhaarNumber || '',
//           createdAt: new Date().toISOString(),
//           updatedAt: new Date().toISOString(),
//           userID,
//           orgID,
//           orgName
//         }

//         await axios.post('/auth/addAgent', agentData, {
//           headers: { Authorization: `Bearer ${token}` }
//         })

//         const userData = {
//           email: formData.email,
//           password: formData.password,
//           usertype: formData.role,
//           userID,
//           orgName
//         }

//         await axios.post('/auth/addUser', userData, {
//           headers: { Authorization: `Bearer ${token}` }
//         })

//         // Show success message with custom alert
//         setAlertConfig({
//           show: true,
//           message: 'Agent added successfully!',
//           type: 'alert',
//           onConfirm: () => {
//             setAlertConfig({ ...alertConfig, show: false })
//             // Call onSubmit with the new agent data
//             onSubmit(agentData)
//             onClose()
//           }
//         })
//         // alert("Agent added successfully!");

//         // Call onSubmit with the new agent data
//         // onSubmit(agentData);
//       }

//       // Reset form and close popup
//       setFormData({
//         role: 'Agent',
//         firstName: '',
//         lastName: '',
//         mobile: '',
//         email: '',
//         username: '',
//         password: '',
//         confirmPassword: '',
//         adhaarNumber: '',
//         userID: '',
//         orgID: '',
//         orgName: ''
//       })

//       // onClose();
//     } catch (error) {
//       console.error(
//         'Error with agent operation:',
//         error.response?.data || error.message
//       )
//       // alert(`Operation failed: ${error.response?.data?.message || error.message}`);
//       // Show error message with custom alert
//       setAlertConfig({
//         show: true,
//         message: `Operation failed: ${
//           error.response?.data?.message || error.message
//         }`,
//         type: 'alert',
//         onConfirm: () => setAlertConfig({ ...alertConfig, show: false })
//       })
//     }
//   }

//   return (
//     <Drawer
//       anchor='right'
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: { width: '600px',height: '550px' },
//         style: { overflow: 'visible', margin: '20px 0px 20px' , padding:'20px' }
//       }}
//     >
//       <CustomAlert
//         show={alertConfig.show}
//         message={alertConfig.message}
//         type={alertConfig.type}
//         onConfirm={alertConfig.onConfirm}
//         onCancel={alertConfig.onCancel}
//       />
//       <div
//         className='drawer-header-user'
//         style={{ padding: '16px', position: 'relative' }}
//       >
       
//         <Typography
//       variant="h5"
//       style={{
//       fontFamily: 'Barlow Condensed',
//       fontWeight: 600,          
//       fontSize: '24px',
//       lineHeight: '133%',      
//       letterSpacing: '0px',
//       verticalAlign: 'middle',
//       opacity: 1,
//     }}
//       >
//         {isEditMode ? 'Edit Agent' : 'Add user'}
//       </Typography>

//         <Button
//           onClick={onClose}
//           style={{
//             position: 'absolute',
//             top: '-1px',
//             left: '-50px',
//             backgroundColor: '#fff',
//             borderRadius: '50%',
//             boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//             minWidth: '40px',
//             height: '40px',
//             padding: '8px',
//             zIndex: 1
//           }}
//         >
//           <CloseIcon style={{ color: 'black' }} />
//         </Button>
//       </div>

//       <div style={{ padding: '10px' }}>
//         <FormControl sx={{ width: '50%', marginBottom: '8px' }}>
//           <InputLabel id='role-select-label'>Role</InputLabel>
//           <Select
//             labelId='role-select-label'
//             name='role'
//             value={formData.role}
//             onChange={handleInputChange}
//             label='Role'
//           >
//             <MenuItem value='Agent'>Agent</MenuItem>
//             <MenuItem value='Executive'>Executive</MenuItem>
//             <MenuItem value='Admin'>Admin</MenuItem>
//           </Select>
//         </FormControl>
// <div
//   style={{
//     width: '633px',
//     height: '1px',
//     backgroundColor: '#DCDCDC',
//     opacity: 1,
//     marginBottom: '5px',
//     marginTop: '3px'
//   }}
// />

//         <Box
//           component='form'
//           noValidate
//           autoComplete='off'
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             gap: 2,
//             width: '50%'
//           }}
//         >
//           <TextField
//             placeholder='First Name'
//             name='firstName'
//             variant='outlined'
//             size='small'
//             value={formData.firstName}
//             onChange={handleInputChange}
//             error={!!formErrors.firstName}
//             helperText={formErrors.firstName}
//              sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//           />
//           <TextField
//             placeholder='Last Name'
//             name='lastName'
//             variant='outlined'
//             size='small'
//             value={formData.lastName}
//             onChange={handleInputChange}
//             error={!!formErrors.lastName}
//             helperText={formErrors.lastName}
//              sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//           />
//           <TextField
            
//             name='mobile'
//             placeholder='Mobile no.'
//             variant='outlined'
//             size='small'
//             value={formData.mobile}
//             onChange={handleInputChange}
//             error={!!formErrors.mobile}
//             helperText={false}
//             sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//               }} />
//           {/* <TextField
//             label='Email'
//             name='email'
//             variant='outlined'
//             size='small'
//             value={formData.email}
//             onChange={handleInputChange}
//             error={!!formErrors.email}
//             helperText={formErrors.email}
//           /> */}
//           <TextField
//             variant="outlined"
//             size="small"
//             value={formData.email}
//             onChange={handleInputChange}
//             error={!!formErrors.email}
//             helperText={false}       // removes helper text
//             placeholder="Enter email"
//             sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//           />
//           {formData.role === 'Agent' ? (
//             <>
//               <TextField
//                 placeholder='Username'
//                 name='username'
//                 variant='outlined'
//                 size='small'
//                 value={formData.username}
//                 onChange={handleInputChange}
//                 error={!!formErrors.username}
//                 helperText={formErrors.username}
//                  sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//               />
//               <TextField
//                 placeholder={
//                   isEditMode
//                     ? 'New Password (leave blank to keep current)'
//                     : 'Password'
//                 }
//                 name='password'
//                 type='password'
//                 variant='outlined'
//                 size='small'
//                 value={formData.password}
//                 onChange={handleInputChange}
//                 error={!!formErrors.password}
//                 helperText={formErrors.password}
//                 required={!isEditMode}
//                  sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//               />
//               {(formData.password || !isEditMode) && (
//                 <TextField
//                   placeholder='Repeat Password'
//                   name='confirmPassword'
//                   type='password'
//                   variant='outlined'
//                   size='small'
//                   value={formData.confirmPassword}
//                   onChange={handleInputChange}
//                   error={!!formErrors.confirmPassword}
//                   helperText={formErrors.confirmPassword}
//                   required={!isEditMode || !!formData.password}
//                    sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//                 />
//               )}
//             </>
//           ) : (
//             <TextField
//               placeholder='Aadhaar Number'
//               name='adhaarNumber'
//               variant='outlined'
//               size='small'
//               value={formData.adhaarNumber}
//               onChange={handleInputChange}
//               error={!!formErrors.adhaarNumber}
//               helperText={formErrors.adhaarNumber}
//                sx={{
//               width: '326px',
//               height: '56px',

//               '& .MuiOutlinedInput-root': {
//                 height: '56px',
//                 padding: 0,
//                 display: 'flex',
//                 justifyContent: 'center',  // horizontal center
//                 alignItems: 'center',      // vertical center
//               },

//               '& .MuiOutlinedInput-input': {
//                 textAlign: 'left',       // horizontal center for placeholder & text
//                 padding: '15px',
//                 height: '100%',
//                 boxSizing: 'border-box',
//               },

//               '& .MuiInputLabel-root': {
//                 display: 'none',           // hide floating label since placeholder is centered
//               },

//               opacity: 1,
//             }}
//             />
//           )}
//         </Box>
//       </div>

//       <div
//         style={{
//           position: 'absolute',
//           bottom: '0',
//           right: '0',
//           width: '100%',
//           padding: '16px',
//           display: 'flex',
//           backgroundColor: "#FAFAFA",
//           justifyContent: 'flex-end'
//         }}
//       >
//         <Button
//           style={{
//             backgroundColor: '#FC350B',
//             color: 'white',
//             marginRight: '8px'
//           }}
//           onClick={handleFormSubmit}
//         >
//           {isEditMode ? 'Update Agent' : 'Add user'}
//         </Button>
//       </div>
//     </Drawer>
//   )
// }

// export default AddUserPopup



import React, { useState, useEffect } from 'react'
import {
  Drawer,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  Box,
  FormControl,
  InputLabel
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import axios from 'axios'
import { useSelector } from 'react-redux'
import './AddUserPopup.css'

/* ---------- Compact TextField Style ---------- */
const compactTextFieldSx = {
  width: '326px',
  height: '44px',

  '& .MuiOutlinedInput-root': {
    height: '44px',
    padding: 0
  },

  '& .MuiOutlinedInput-input': {
    padding: '10px 14px',
    fontSize: '14px',
    height: '100%',
    boxSizing: 'border-box'
  },

  '& .MuiFormHelperText-root': {
    display: 'none'
  }
}


/* ---------- Custom Alert ---------- */
const CustomAlert = ({ show, message, type, onConfirm, onCancel }) => {
  if (!show) return null
  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-box">
        <h3>{type === 'confirm' ? 'Confirm' : 'Alert'}</h3>
        <p>{message}</p>
        <div className="custom-alert-buttons">
          {type === 'confirm' && (
            <button onClick={onCancel}>Cancel</button>
          )}
          <button onClick={onConfirm}>OK</button>
        </div>
      </div>
    </div>
  )
}

const AddUserPopup = ({
  open,
  onClose,
  onSubmit,
  isEditMode = false,
  userData = null
}) => {
  const userDataStore = useSelector(state => state.appStore?.user)
const orgID = userDataStore?.orgID
const orgName = userDataStore?.orgName

  const [formData, setFormData] = useState({
    role: 'Agent',
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    username: '',
    password: '',
    confirmPassword: '',
    adhaarNumber: '',
    licenceNumber: '123456',
    district: 'Rampur',
    taluk: 'Sadar',
    userID: '',
    orgID: '',
    orgName: ''
  })

  const [formErrors, setFormErrors] = useState({})
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    message: '',
    type: 'alert'
  })
const handleSubmit = async () => {
  // 🔒 Basic validation
  if (!formData.firstName || !formData.mobile) {
    setAlertConfig({
      show: true,
      type: 'alert',
      message: 'First name and mobile number are required',
      onConfirm: () => setAlertConfig({ show: false })
    })
    return
  }

  if (formData.role === 'Agent' && formData.password !== formData.confirmPassword) {
    setAlertConfig({
      show: true,
      type: 'alert',
      message: 'Password and Confirm Password do not match',
      onConfirm: () => setAlertConfig({ show: false })
    })
    return
  }

  const payload = {
    role: formData.role,
    firstName: formData.firstName,
    lastName: formData.lastName,
    mobile: formData.mobile,
    email: formData.email,
    username: formData.username,
    password: formData.password,
    adhaarNumber: formData.adhaarNumber,
    licenceNumber: formData.licenceNumber || '123456',
    district: formData.district || 'Rampur',
    taluk: formData.taluk || 'Sadar',
    orgID,
    orgName
  }

  try {
    const res = await axios.post('/auth/addAgent', payload)

    if (res.data?.success) {
      setAlertConfig({
        show: true,
        type: 'alert',
        message: 'User added successfully',
          onConfirm: () => {
          setAlertConfig({ show: false }) // hide alert
          onClose() // close drawer
        }
      })
    } else {
      throw new Error(res.data?.message || 'Failed to add user')
    }
  } catch (err) {
  setAlertConfig({
    show: true,
    type: 'alert',
    message: err.response?.data?.message || err.message,
    onConfirm: () => setAlertConfig({ show: false }) // hide alert
  })
}

}
  useEffect(() => {
    if (isEditMode && userData) {
      setFormData({
        role: userData.userType || 'Agent',
        firstName: userData.FirstName || '',
        lastName: userData.LastName || '',
        mobile: userData.MobileNumber || '',
        email: userData.email || '',
        username: userData.username || '',
        password: '',
        confirmPassword: '',
        adhaarNumber: userData.adhaarNumber || '',
        userID: userData.userID || '',
        orgID: userData.orgID || '',
        orgName: userData.orgName || ''
      })
    }
  }, [isEditMode, userData, open])

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '520px', height: 'calc(100vh - 40px)'},
        // style: { padding: '20px', overflow: 'hidden' }
                style: { overflow: 'visible', margin: '20px 0px 20px' , padding:'20px' }

      }}
    >
      <CustomAlert {...alertConfig} />
 <Button
  onClick={onClose}
  sx={{
    position: 'absolute',
    top: '14px',
    left: '-48px',          // 👈 pushes it outside the drawer
    backgroundColor: '#fff',
    borderRadius: '50%',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    minWidth: '40px',
    height: '40px',
    zIndex: 1301,          // higher than drawer
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  }}
>
  <CloseIcon sx={{ color: '#000' }} />
</Button>
      {/* Header */}
      <div style={{ position: 'relative', paddingBottom: '8px' }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontSize: '22px' }}
        >
          {isEditMode ? 'Edit Agent' : 'Add User'}
        </Typography>

        {/* <Button
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            minWidth: '36px',
            height: '36px'
          }}
        >
          <CloseIcon />
        </Button> */}
       

      </div>

      {/* Role */}
      <FormControl sx={{ width: '50%', mb: 1 }}>
        <InputLabel>Role</InputLabel>
        <Select
          value={formData.role}
          label="Role"
          name="role"
          onChange={handleInputChange}
        >
          <MenuItem value="Agent">Agent</MenuItem>
          <MenuItem value="Executive">Executive</MenuItem>
          <MenuItem value="Admin">Admin</MenuItem>
        </Select>
      </FormControl>

      <div style={{ height: '1px', background: '#DCDCDC', marginBottom: '8px' }} />

      {/* ---------- Scrollable Form Body ---------- */}
      <div>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}
        >
          <TextField placeholder="First Name" name="firstName" value={formData.firstName} onChange={handleInputChange} sx={compactTextFieldSx} />
          <TextField placeholder="Last Name" name="lastName" value={formData.lastName} onChange={handleInputChange} sx={compactTextFieldSx} />
          <TextField placeholder="Mobile No." name="mobile" value={formData.mobile} onChange={handleInputChange} sx={compactTextFieldSx} />
          <TextField placeholder="Email" name="email" value={formData.email} onChange={handleInputChange} sx={compactTextFieldSx} />

          {formData.role === 'Agent' ? (
            <>
              <TextField placeholder="Username" name="username" value={formData.username} onChange={handleInputChange} sx={compactTextFieldSx} />
              <TextField type="password" placeholder="Password" name="password" value={formData.password} onChange={handleInputChange} sx={compactTextFieldSx} />
              <TextField type="password" placeholder="Confirm Password" name="confirmPassword" value={formData.confirmPassword} onChange={handleInputChange} sx={compactTextFieldSx} />
              <TextField placeholder="Licence Number" name="licenceNumber" value={formData.licenceNumber} onChange={handleInputChange} sx={compactTextFieldSx} />
              <TextField placeholder="District" name="district" value={formData.district} onChange={handleInputChange} sx={compactTextFieldSx} />
              <TextField placeholder="Taluk" name="taluk" value={formData.taluk} onChange={handleInputChange} sx={compactTextFieldSx} />
            </>
          ) : (
            <TextField placeholder="Aadhaar Number" name="adhaarNumber" value={formData.adhaarNumber} onChange={handleInputChange} sx={compactTextFieldSx} />
          )}
        </Box>
      </div>

      {/* Footer */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '100%',
          padding: '12px',
          background: '#FAFAFA',
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          variant="contained"
          sx={{ backgroundColor: '#FC350B' }}
            onClick={handleSubmit}

        >
          {isEditMode ? 'Update Agent' : 'Add User'}
        </Button>
      </div>
    </Drawer>
  )
}

export default AddUserPopup
